export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '2.2.1',
};
//# sourceMappingURL=buildEnv.js.map